// @mui
import { memo } from "react";
// @mui
import { Stack, Box } from "@mui/material";
// config
import { NAV } from "../../../config-global";
// utils
import { hideScrollbarX } from "../../../utils/cssStyles";
// hooks
import { useAuthContext } from "../../../auth/useAuthContext";
// components
import Logo from "../../../components/logo";
import { NavSectionMini } from "../../../components/nav-section";
//
import { useNavConfig } from "./config-navigation";
import NavToggleButton from "./NavToggleButton";
import { filterNavByRole } from "./utils";

// ----------------------------------------------------------------------

function NavMini() {
  const { user } = useAuthContext();

  // Get navigation config based on user role and patient ID
  const navConfig = useNavConfig();
  const filteredNavConfig = filterNavByRole(navConfig, user);

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: "fixed",
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: 2, my: 2 }} />

        <NavSectionMini data={filteredNavConfig} />
      </Stack>
    </Box>
  );
}

export default memo(NavMini);
